<template>
    <div>
        <div class="row py-3">
            <div class="col-md-3">
                <el-button
                    type="primary"
                    class="btn btn-primary"
                    @click="showModal()"
                    >Crear noticia</el-button
                >
            </div>
        </div>
        <div>
            <section v-if="!initialLoading">
                <div class="row">
                    <div class="col-12">
                        <div class="table-responsive">
                            <table
                                id="data-list-news"
                                class="table-hover-animation table-striped table-bordered"
                            >
                                <caption>
                                    Listado de noticias
                                </caption>
                                <thead>
                                    <tr>
                                        <th>Título</th>
                                        <th>Autor</th>
                                        <th>Fecha de publicación</th>
                                        <th>Etiquetas</th>
                                        <th>Estado</th>
                                        <th>Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(newItem, index) in news"
                                        :key="index"
                                    >
                                        <td>{{ newItem.title }}</td>
                                        <td>{{ newItem.author.name }}</td>
                                        <td>{{ newItem.created_at }}</td>
                                        <td>
                                            <el-tag
                                                v-for="tag in newItem.tags"
                                                :key="tag.id"
                                                :color="tag.color"
                                                effect="dark"
                                                >{{ tag.name }}</el-tag
                                            >
                                        </td>
                                        <td>
                                            <el-tag
                                                v-if="newItem.status"
                                                type="success"
                                                effect="dark"
                                                >Publicado</el-tag
                                            >
                                            <el-tag
                                                v-else
                                                type="info"
                                                effect="dark"
                                                >Inactivo</el-tag
                                            >
                                        </td>
                                        <td>
                                            <el-select
                                                v-model="optionSelected"
                                                @change="
                                                    getOptionSelected(newItem)
                                                "
                                                clearable
                                                size="default"
                                                clear-icon
                                                id="customize_select"
                                            >
                                                <el-option
                                                    v-for="option in options"
                                                    :key="option.value"
                                                    :label="option.label"
                                                    :value="option.value"
                                                />
                                            </el-select>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>
            <custom-spinner v-else></custom-spinner>
        </div>

        <!-- add news -->
        <div
            class="modal fade"
            id="tagModal"
            role="dialog"
            tabindex="-1"
            aria-labelledby="newsModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1
                            v-if="showModalEdit"
                            class="modal-title fs-5"
                            id="newsModalLabel"
                        >
                            Editar noticia
                        </h1>
                        <h1 v-else class="modal-title fs-5" id="newsModalLabel">
                            Crear noticia
                        </h1>
                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            @click="clearForm()"
                        ></button>
                    </div>
                    <div class="modal-body">
                        <form
                            @submit.prevent="submit"
                            id="upload"
                            method="post"
                            enctype="multipart/form-data"
                        >
                            <div class="row">
                                <div class="mb-3 col-12">
                                    <label for="" class="form-label"
                                        >Título:
                                    </label>
                                    <input
                                        type="text"
                                        v-model="form.title"
                                        class="form-control"
                                        placeholder="Ingrese el título"
                                    />
                                </div>
                                <div class="mb-3 col-12">
                                    <label for="" class="form-label"
                                        >Descripción:
                                    </label>
                                    <input
                                        type="text"
                                        v-model="form.description"
                                        class="form-control"
                                        placeholder="Ingrese la descripción"
                                    />
                                </div>
                                <div class="col-12">
                                    <label>Subir portada</label>
                                    <el-upload
                                        class="picture-card"
                                        ref="newThumbnail"
                                        action=""
                                        drag
                                        accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG, .webp, .WEBP, .avif, .AVIF"
                                        :on-change="onUploadChange"
                                        :http-request="submit"
                                        :multiple="false"
                                        :limit="1"
                                        :auto-upload="false"
                                        :file-list="fileList"
                                        :on-exceed="handleExceed"
                                    >
                                        <em class="el-icon-upload"></em>
                                        <div class="el-upload__text">
                                            Suelta tu archivo aquí o
                                            <em>haz clic para cargar</em>
                                        </div>
                                        <div slot="tip" class="el-upload__tip">
                                            Solo archivos jpg/png/webp con un
                                            tamaño menor de 500kb
                                        </div>
                                    </el-upload>
                                </div>

                                <div class="col-8">
                                    <label for="" class="form-label"
                                        >Etiquetas:
                                    </label>
                                    <el-select
                                        v-model="form.tags"
                                        class="m-2"
                                        placeholder="Seleccione las etiquetas"
                                        no-data-text="No se encontraron etiquetas"
                                    >
                                        <el-option
                                            v-for="(tag, index) in tags"
                                            :key="index"
                                            :label="tag.name"
                                            :value="tag.id"
                                            @click="addTag(tag)"
                                        />
                                    </el-select>
                                    <el-button
                                        type="primary"
                                        :icon="Plus"
                                        @click="
                                            fieldCreateTag = !fieldCreateTag
                                        "
                                    />
                                </div>
                                <div class="col-12 my-2" v-if="fieldCreateTag">
                                    <label for="tagName" class="form-label"
                                        >Nombre de la etiqueta:
                                    </label>
                                    <input
                                        style="display: inline"
                                        size="small"
                                        type="text"
                                        v-model="tag.name"
                                        class="form-control w-50 ml-1 mr-4"
                                        placeholder="Ingrese el nombre"
                                        clearable
                                    />

                                    <label
                                        for="tagColor"
                                        class="form-label mx-4"
                                        >Seleccione el color:
                                    </label>
                                    <el-color-picker v-model="tag.color" />
                                    <button
                                        type="button"
                                        @click="storeTag"
                                        class="btn btn-primary ml-5"
                                    >
                                        Guardar
                                    </button>
                                </div>

                                <div class="col-12 py-3">
                                    <el-tag
                                        v-for="(
                                            selectedTag, index
                                        ) in form.selectedTags"
                                        :key="index"
                                        effect="dark"
                                        round
                                        class="m-1"
                                        :color="selectedTag.color"
                                        closable
                                        @close="deleteTag(selectedTag.id)"
                                    >
                                        {{ selectedTag.name }}
                                    </el-tag>
                                </div>

                                <div class="mb-5 col-12 pb-5 pt-3">
                                    <label for="" class="form-label"
                                        >Contenido:
                                    </label>
                                    <QuillEditor
                                        ref="quill"
                                        v-model:content="form.content"
                                        contentType="html"
                                        theme="snow"
                                        toolbar="full"
                                        :modules="modules"
                                    />
                                </div>

                                <div class="text-center mt-5">
                                    <button
                                        type="button"
                                        @click="submit"
                                        class="btn btn-primary"
                                    >
                                        Guardar
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import ModalComponent from "../ModalComponent.vue";
import CustomSpinner from "../../common/custom-spinner/CustomSpinner.vue";
import language from "../../api/traduction_es";

import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import BlotFormatter from "quill-blot-formatter";
import { Plus } from "@element-plus/icons-vue";

export default {
    computed: {
        Plus() {
            return Plus;
        },
    },
    data() {
        return {
            tag: {
                name: "",
                color: "",
            },
            modules: {
                name: "blotFormatter",
                module: BlotFormatter,
                options: {
                    /* options */
                },
            },
            fieldCreateTag: false,
            tags: [],
            form: {
                content: "",
                selectedTags: [],
            },
            initialLoading: false,
            moment: moment,
            news: [],
            fileList: [],
            mNew: {},
            optionSelected: "",
            showModalEdit: false,
            options: [
                {
                    value: "1",
                    label: "Editar",
                },
                {
                    value: "2",
                    label: "Publicar / Ocultar",
                },
            ],
        };
    },
    components: {
        "custom-modal": ModalComponent,
        "custom-spinner": CustomSpinner,
        QuillEditor,
    },

    mounted() {
        this.listNews();
        this.listTags();
    },

    methods: {
        deleteTag(id) {
            let index = this.form.selectedTags
                .map((object) => object.id)
                .indexOf(id);
            this.form.selectedTags.splice(index, 1);
        },
        getOptionSelected(object) {
            let option = this.optionSelected;
            console.log(object);
            switch (option) {
                case "1":
                    let copyObject = Object.assign({}, object);
                    this.showEditModal(copyObject);
                    break;
                case "2":
                    this.changeStatus(object.id);
                    this.optionSelected = "";
                    break;
                default:
                    console.log("Error");
                    break;
            }
            this.optionSelected = "";
        },
        async changeStatus(id) {
            const form = {
                id: id,
            };
            await axios.patch("/news/change-status", form).then((response) => {
                this.listNews();
            });
        },
        addTag(tag) {
            if (this.form.selectedTags.includes(tag)) {
                return;
            } else {
                this.form.selectedTags.push(tag);
            }
        },
        validateTag() {
            if (
                !this.tag.name ||
                this.tag.name.trim() === "" ||
                this.tag.name.length === 0
            ) {
                this.$message.warning("Ingrese el nombre de la etiqueta!");
                return false;
            }
            if (
                !this.tag.color ||
                this.tag.color.trim() === "" ||
                this.tag.color.length === 0
            ) {
                this.$message.warning("Ingrese el color de la etiqueta!");
                return false;
            }
            return true;
        },

        showEditModal(object) {
            this.optionSelected = "";
            this.showModalEdit = true;
            $("#tagModal").modal("show");
            this.form.id = object.id;
            this.form.title = object.title;
            this.form.description = object.description;
            this.form.selectedTags = object.tags;
            this.$refs.quill.setHTML(object.content);
            this.fillFiles(object);
        },
        handleExceed(file) {
            const isLt1M = file.size > 3000000;

            if (!isLt1M) {
                this.$message.error("El archivo no debe pesar más de 3Mb!");
                this.$refs.newThumbnail.clearFiles();
                return false;
            }
        },
        onUploadChange(file) {
            this.fileList = [];

            const isImage =
                file.raw.type === "image/jpeg" ||
                file.raw.type === "image/webp" ||
                file.raw.type === "image/png" ||
                file.raw.type === "image/avif" ||
                file.raw.type === "image/jpg";

            // 100kb
            const isLt1M = file.size < 3000000;

            if (!isImage) {
                this.$message.error(
                    "Solo puede cargar archivos en formato jpg|jpeg|png."
                );
                this.$refs.newThumbnail.clearFiles();
                return false;
            }
            if (!isLt1M) {
                this.$message.error("El archivo no debe pesar más de 3Mb!");
                this.$refs.newThumbnail.clearFiles();
                return false;
            }
            // let reader = new FileReader();
            // reader.readAsDataURL(file.raw);
            // reader.onload = function (e) {
            //   console.log(this.result);
            // };
            this.fileList.push(file);
        },
        validateNews() {
            if (
                !this.form.title ||
                this.form.title.trim() === "" ||
                this.form.title.length === 0
            ) {
                this.$message.warning("Ingrese el título de la noticia!");
                return false;
            }
            if (
                !this.form.description ||
                this.form.description.trim() === "" ||
                this.form.description.length === 0
            ) {
                this.$message.warning("Ingrese la descripción de la noticia!");
                return false;
            }
            if (!this.$refs.newThumbnail || this.fileList.length == 0) {
                this.$message.warning(
                    "No ha seleccionado la portada de la noticia!"
                );
                return false;
            }

            if (
                !this.form.content ||
                this.form.content.trim() === "" ||
                this.form.content.length === 0
            ) {
                this.$message.warning("Ingrese el contenido de la noticia!");
                return false;
            }

            if (this.form.selectedTags.length === 0) {
                this.$message.warning("Seleccione al menos una etiqueta!");
                return false;
            }
            return true;
        },
        storeTag: async function () {
            if (this.validateTag()) {
                try {
                    const { data } = await axios.post(`/tags/store`, this.tag);
                    if (data.success) {
                        this.listTags();
                        this.tag = {};
                        this.fieldCreateTag = false;
                    }
                } catch (error) {
                    alert(error);
                }
            }
        },
        showModal() {
            $("#tagModal").modal("show");
        },

        listTags: async function () {
            this.initialLoading = true;
            const { data } = await axios.get(`/tags/list`);
            this.tags = data;
        },

        async storeNew(formdata) {
            const { data } = await axios.post("/news/store", formdata, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            if (data.success) {
                this.listNews();
                this.clearForm();
            }
        },
        async updateNew(formdata) {
            const { data } = await axios.post("/news/update", formdata, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            if (data.success) {
                this.listNews();
                this.clearForm();
            }
        },

        async submit() {
            try {
                if (this.validateNews()) {
                    const formdata = new FormData();
                    formdata.append("title", this.form.title);
                    formdata.append("description", this.form.description);
                    formdata.append("content", this.form.content);
                    this.form.selectedTags.forEach((tag, i) =>
                        formdata.append(`tags[${i}]`, JSON.stringify(tag))
                    );
                    formdata.append("thumbnail", this.fileList[0].raw);
                    if (this.showModalEdit) {
                        formdata.append("id", this.form.id);
                        this.updateNew(formdata);
                    } else {
                        this.storeNew(formdata);
                    }
                    $("#tagModal").modal("hide");
                }
            } catch (error) {
                alert(error);
            }
        },
        loadDataTable() {
            $(document).ready(function () {
                $("#data-list-news").DataTable(language);
            });
        },
        fillFiles(object) {
            this.fileList = [
                {
                    name: "imagen",
                    url: `${object.thumbnail}`,
                    raw: `${object.thumbnail}`,
                },
            ];
        },

        listNews: async function () {
            this.initialLoading = true;
            const { data } = await axios.get(`/news/list`);
            this.news = data;
            this.initialLoading = false;
            this.loadDataTable();
        },
        clearForm() {
            this.showModalEdit = false;
            this.form = {
                content: "",
                selectedTags: [],
            };
            this.fileList = [];
            this.$refs.quill.setHTML("");
        },
    },
};
</script>
